import firebase from 'firebase/app';
import 'firebase/auth';

// Đăng nhập tài khoản dịch vụ cho app "database" (dùng để đọc Firestore theo rule).
// Trả về một promise singleton để các nơi khác có thể `await` trước khi đọc
// Firestore, tránh race "đọc khi chưa xác thực" lúc mở lại tab
// (đọc khi token chưa sẵn sàng → permission-denied → trước đây bị xoá mất phiên).
//
// Dùng Persistence.LOCAL để phiên dịch vụ sống qua việc tab bị treo/ngủ cả ngày,
// token tự refresh thay vì phải đăng nhập lại từ đầu mỗi lần mở.
let databaseAuthPromise = null;

export const ensureDatabaseAuth = () => {
  const auth = firebase.app('database').auth();

  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  if (!databaseAuthPromise) {
    databaseAuthPromise = auth
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() =>
        auth.signInWithEmailAndPassword(
          process.env.REACT_APP_EMAIL_AUTH,
          process.env.REACT_APP_PASS_AUTH
        )
      )
      .catch((error) => {
        // Cho phép thử lại ở lần gọi sau nếu lần này thất bại (mạng chập chờn),
        // thay vì kẹt mãi ở promise đã reject.
        databaseAuthPromise = null;
        throw error;
      });
  }

  return databaseAuthPromise;
};
